module.exports = __webpack_public_path__ + "img/chahua.9735f3cb.png";